<template>
  <div class="overflow-x-auto text-xs h-[70vh]">
    <table class="min-w-full table-auto border border-gray-300">
      <thead class="bg-gray-100">
        <tr>
          <th class="p-2 border">Үйлдэл</th>
          <th class="p-2 border">Регистрийн дугаар</th>
          <th class="p-2 border">Лого</th>
          <th class="p-2 border">Байгууллагын нэр /монголоор/</th>
          <th class="p-2 border">Байгууллагын нэр /англиар/</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(request, index) in requests" :key="index" class="border-t">
          <td class="flex justify-center items-center p-2 text-center h-full">
            <button
              @click="showModal(request.id)"
              class="bg-sky-500 text-white py-1 px-2 rounded text-xs flex items-center justify-center"
            >
              <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 384 512">
                <path
                  d="M0 448c0 35.3 28.7 64 64 64l160 0 0-128c0-17.7 14.3-32 32-32l128 0 0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384l-128 0 0 128L384 384z"
                />
              </svg>
              Дэлгэрэнгүй
            </button>
          </td>
          <td class="p-2 text-center">
            {{ request.registration_number || "" }}
          </td>
          <td class="p-2 text-center">
            <img
              v-if="
                request.company_info?.translations?.logo &&
                request.company_info.translations.logo !== 'NULL'
              "
              :src="request.company_info.translations.logo"
              alt="Company Logo"
              class="mx-auto w-[100px]"
            />
          </td>
          <td class="p-2 text-center">
            {{ request.company_info?.translations?.name?.mn || "" }}
          </td>
          <td class="p-2 text-center">
            {{ request.company_info?.translations?.name?.en || "" }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <YellowEditCompanyModal
    v-if="isModal"
    :id="companyId"
    @closeModal="closeModal"
  />
</template>

<script>
import { ref, watch } from "vue";
import YellowEditCompanyModal from "./YellowEditCompanyModal.vue";

export default {
  name: "YellowCompanyTable",
  components: {
    YellowEditCompanyModal,
  },
  props: {
    data: Array,
  },
  emits: ["fetchData"],
  setup(props, { emit }) {
    const requests = ref(props.data);

    watch(
      () => props.data,
      (newData) => {
        requests.value = newData;
      }
    );

    const isModal = ref(false);
    const companyId = ref(null);
    const showModal = (id) => {
      if (id) {
        companyId.value = id;
      }
      isModal.value = true;
    };

    const closeModal = () => {
      isModal.value = false;
      emit("fetchData");
    };

    return {
      requests,
      isModal,
      showModal,
      companyId,
      closeModal,
    };
  },
};
</script>
